import { isEmpty } from 'lodash';

import { InteractiveTable, InteractiveTableCellProps, TooltipText } from '@dreryk/react-components';

import { MedicalServicePractitionerSpecialties } from '../../practitioner.types';

type MedicalServicePractitionerSpecialtiesCellProps = InteractiveTableCellProps<MedicalServicePractitionerSpecialties> & {
   readonly defaultValue: MedicalServicePractitionerSpecialties;
};

export const MedicalServicePractitionerSpecialtiesCell = (
   props: MedicalServicePractitionerSpecialtiesCellProps
): JSX.Element => {
   return (
      <InteractiveTable.CustomCell<MedicalServicePractitionerSpecialties>
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
      >
         {(specialties) => {
            const specialtyNames = specialties.join(', ');
            const noSpecialties = isEmpty(specialtyNames);

            return (
               <TooltipText
                  testId={props.testId}
                  lines={2}
                  content={
                     <ul>
                        {specialties.map((specialty) => (
                           <li key={specialty}>{specialty}</li>
                        ))}
                     </ul>
                  }
               >
                  <>{noSpecialties ? '-' : specialtyNames}</>
               </TooltipText>
            );
         }}
      </InteractiveTable.CustomCell>
   );
};
